module.exports = "/images/smallArrowUp.png?343168c2c4b90c508778422966d75a45";